export default __webpack_public_path__ + "static/media/treyd_square_logo_green.6590503e.svg";